import * as React from 'react';
const ToastContext = /*#__PURE__*/React.createContext({
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onClose() {}

});
export default ToastContext;